export enum CohorteEnum {
  SIG2412 = 'SIG2412-FODE',
  SIG2408 = 'SIG2408-FODE',
  SIG2402 = 'SIG2402-FODE',
  SIG2502 = 'SIG2502-FODE',
  SIG2505 = 'SIG2505-FODE',
  SIG2508 = 'SIG2508-FODE',
  SIG2509 = 'SIG2509-FODE',
  SIG2510 = 'SIG2510-FODE',
  SIG2511 = 'SIG2511-FODE',
}
